import React, { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col } from "react-bootstrap";
import _ from "lodash";
import ApiRegion from "../../../core/api/api.region";
import { CreateOrEditRegion } from "./CreateOrEditRegion";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { Route, useLocation, useNavigate } from "react-router-dom";
import ChangeOrderRegion from "./ChangeOrderRegion";
import SwapVert from "@mui/icons-material/SwapVert";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";

const Region = () => {
  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [refresh, setRefresh] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const background = location.state && location.state.background;
  const [showModalEditRegion, setShowModalEditRegion] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [showModalRegionOrder, setShowModalRegionOrder] = useState(false);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiRegion.getAll({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);
  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  const onSubmit = async (data) => {
    const apiData = await ApiRegion.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });

    setListData(apiData);
    tools.setPageNumber(data, searchParams, setValue);
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/regions?${queryString}`);
  };

  return (
    <div>
      {background && <Route path="/regions/createOrEditRegion" children={<CreateOrEditRegion />} />}
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت شهر ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست شهرهای ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <div className="card-toolbar">
              <Button
                className="mr-2"
                onClick={() => {
                  setSelectedRegion(null);
                  setShowModalEditRegion(true);
                }}
              >
                <AddCircle className="mr-1" />
                ایجاد شهر جدید
              </Button>
              <Button
                variant="success"
                onClick={() => {
                  setShowModalRegionOrder(true);
                }}
              >
                <SwapVert className="mr-1" />
                ترتیب نمایش
              </Button>
            </div>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    callBack={callBackJustForRunUseEffect}
                    setShowModalEditRegion={setShowModalEditRegion}
                    setSelectedRegion={setSelectedRegion}
                  />
                </Col>
                {showModalEditRegion && (
                  <CreateOrEditRegion
                    showModalEditRegion={showModalEditRegion}
                    setShowModalEditRegion={setShowModalEditRegion}
                    selectedRegion={selectedRegion}
                  />
                )}
                {showModalRegionOrder && (
                  <ChangeOrderRegion
                    showModalRegionOrder={showModalRegionOrder}
                    setShowModalRegionOrder={setShowModalRegionOrder}
                  />
                )}
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Region;
